import {
  Box,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useFormPermissions } from '../../FormPermissionProvider';

// Helper to display values nicely
function formatValue(value) {
  if (value == null) return '—';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  return String(value);
}

function LiveFormPermissionsPreviewTable() {
  const { permissions, permittedByDefault, staticPermissions } =
    useFormPermissions();

  const permissionsEntries = permissions
    ? Object.entries(permissions).sort(([a], [b]) => a.localeCompare(b))
    : [];

  const staticPermissionsEntries = staticPermissions
    ? Object.entries(staticPermissions).sort(([a], [b]) => a.localeCompare(b))
    : [];

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 2,
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        overflow: 'hidden',
      }}>
      <Box>
        <Box>
          <Typography variant="subtitle2">
            <Typography variant="subtitle2" color="warning" component="span">
              Permitted By Default:
            </Typography>{' '}
            {permittedByDefault ? 'YES' : 'NO'}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box>
        <Typography color="warning" variant="subtitle2">
          API Permissions
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Field</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Permission</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {permissionsEntries.map(([key, value]) => (
              <TableRow key={key} hover>
                <TableCell
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: 13,
                    whiteSpace: 'nowrap',
                    verticalAlign: 'top',
                  }}>
                  {key}
                </TableCell>

                <TableCell
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: 13,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}>
                  {formatValue(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box>
        <Typography color="warning" variant="subtitle2">
          Static Permissions
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Field</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Permission</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {staticPermissionsEntries.map(([key, value]) => (
              <TableRow key={key} hover>
                <TableCell
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: 13,
                    whiteSpace: 'nowrap',
                    verticalAlign: 'top',
                  }}>
                  {key}
                </TableCell>

                <TableCell
                  sx={{
                    fontFamily: 'monospace',
                    fontSize: 13,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}>
                  {formatValue(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}

export default LiveFormPermissionsPreviewTable;
